import { render, staticRenderFns } from "./FormRegistInfoStreamax.vue?vue&type=template&id=4bdc080c&scoped=true&"
import script from "./FormRegistInfoStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormRegistInfoStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormRegistInfoStreamax.vue?vue&type=style&index=0&id=4bdc080c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc080c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4bdc080c', component.options)
    } else {
      api.reload('4bdc080c', component.options)
    }
    module.hot.accept("./FormRegistInfoStreamax.vue?vue&type=template&id=4bdc080c&scoped=true&", function () {
      api.rerender('4bdc080c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/RegistInfo/FormRegistInfoStreamax.vue"
export default component.exports